// libraries
import * as navigationHooks from '@makemydeal/dr-dash-store/hooks/navigation';
import { RouteValues } from '@makemydeal/dr-dash-store/routeConstants';

import { ChevronLeftIcon } from '@interstate/components/Icons/ChevronLeftIcon';
import { Button } from '@interstate/components/Button';

const BackToMyDealButton = () => {
    const handleBackButtonClick = navigationHooks.useNavigate(RouteValues.DASHBOARD);
    return (
        <Button
            buttonStyle="aux"
            id="MyButton"
            onClick={handleBackButtonClick}
            size="small"
            startIcon={<ChevronLeftIcon />}
            data-testid="back-to-my-deal"
        >
            {'Back'}
        </Button>
    );
};

export default BackToMyDealButton;
